import { apiService } from './api.service';
import { CR_API_ENDPOINTS, QUERY_PARAMS } from '../constants';
import { AsanaTask, TaskSearchResult } from '../types';

class TasksService {
  /** Searches Asana and ClickUp jobs by customer name (SOR-backed). */
  async getAllTasks(search?: string): Promise<TaskSearchResult[]> {
    const params = search ? { [QUERY_PARAMS.SEARCH]: search } : undefined;
    const results = await apiService.get<TaskSearchResult[]>(CR_API_ENDPOINTS.TASKS, params);
    return Array.isArray(results) ? results : [];
  }

  async getAsanaTaskById(taskGid: string): Promise<AsanaTask> {
    return apiService.get<AsanaTask>(`${CR_API_ENDPOINTS.ASANA_TASKS}/${encodeURIComponent(taskGid)}`);
  }

  async getClickUpTaskById(taskId: string): Promise<AsanaTask> {
    return apiService.get<AsanaTask>(`${CR_API_ENDPOINTS.CLICKUP_TASKS}/${encodeURIComponent(taskId)}`);
  }
}

export const tasksService = new TasksService();
